// eslint-disable-next-line import/no-extraneous-dependencies
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { mensagemDeErroEmBlob } from '../../utils/ErroEmBlob/ErroEmBlob'
import { apiService } from '../_config_/apiservice'

const serializarRepeat = (paramsAux: any) =>
  Qs.stringify(paramsAux, { arrayFormat: 'repeat' })

export const getMensagensEnviadas = async (
  cancel: any,
  canal: string[],
  status: string[],
  clienteId: number[],
  remetente: string[],
  dataInicio: string,
  dataFim: string,
  query: string,
  page: number
): Promise<GetMensagensEnviadasType | { message: string }> => {
  try {
    const result = await apiService.get('app/mensagem-enviada', {
      cancelToken: cancel.token,
      params: {
        canal,
        status,
        clienteId,
        remetente,
        dataInicio,
        dataFim,
        query,
        page: page - 1,
        size: 12,
      },
      paramsSerializer: serializarRepeat,
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getMensagensEnviadasResumo = async (
  cancel: any,
  canal: string[],
  status: string[],
  clienteId: number[],
  remetente: string[],
  dataInicio: string,
  dataFim: string,
  query: string
): Promise<GetMensagensResumoType | { message: string }> => {
  try {
    const result = await apiService.get('app/mensagem-enviada/resumo', {
      cancelToken: cancel.token,
      params: {
        canal,
        status,
        clienteId,
        remetente,
        dataInicio,
        dataFim,
        query,
      },
      paramsSerializer: serializarRepeat,
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Números (só dígitos) que já enviaram mensagem dentro do que o usuário enxerga: opções do filtro.
export const getMensagensEnviadasRemetentes = async (): Promise<
  string[] | { message: string }
> => {
  try {
    const result = await apiService.get('app/mensagem-enviada/remetentes')
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Exportação do recorte INTEIRO (os mesmos filtros da tela, sem paginação). Vem como blob via
// axios — `window.open` perderia os headers Authorization/X-TENANT-ID e o download voltaria 401.
// Acima do teto a API recusa com orientação, e o corpo do erro também chega como Blob.
export const getMensagensEnviadasExport = async (
  canal: string[],
  status: string[],
  clienteId: number[],
  remetente: string[],
  dataInicio: string,
  dataFim: string,
  query: string
): Promise<Blob | { message: string }> => {
  try {
    const result = await apiService.get('app/mensagem-enviada/export', {
      responseType: 'blob',
      params: {
        canal,
        status,
        clienteId,
        remetente,
        dataInicio,
        dataFim,
        query,
      },
      paramsSerializer: serializarRepeat,
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return { message: await mensagemDeErroEmBlob(error) }
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getMensagemEnviadaDetalhe = async (
  id: string | undefined
): Promise<GetMensagemEnviadaDetalheType | { message: string }> => {
  try {
    const result = await apiService.get(`app/mensagem-enviada/${id}`)
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
